<template>
    <div class="account-controls">
        
        <button class="_primary" @click="toggleCreateModal()" v-if="user.role === 'admin'">
            Create Account
        </button>

        <!-- <button
            class="_approve"
            key="0"
            @click="toggleEditModal()"
            v-if="selectedAccounts.length === 1"
        >
            Edit
        </button> -->

        <button
            class="_approve"
            key="2"
            :disabled="!selectedAccounts.length || checkSelectedAccountStatus('disabled')"
            @click="toggleEnableDisableAccount(true)"
        >
            Enable
        </button>

        <button
            class="_deny"
            key="1"
            :disabled="!selectedAccounts.length || checkSelectedAccountStatus('active')"
            @click="toggleEnableDisableAccount(false)"
        >
            Disable
        </button>
    </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'

// import DropdownOption from '@/components/utils/DropdownOption'
export default {
    computed: {
        ...mapFields('registeredAccount', [
            'params',
            'selectedAccounts',
            'list',
            'accountForm',
            'isUpdateAccount'
        ]),

        ...mapFields('auth', [
            'user',
        ]),
        
        filterOptions () {
			return [
				{text: 'Paid', value: 'paid'},
				{text: 'Pending', value: 'pending'},
				{text: 'Late', value: 'late'},
			]
        },
    },

    methods: {
        /* Edit Account Methods */
        async toggleEditModal () {
            const { id } = this.list.data.find(item => item.id === this.selectedAccounts[0])

            this.$router.push(`/registered-accounts/edit/${id}`)
        },

        /* Toggle Confirm Enable/Disable Account */
        toggleEnableDisableAccount (enableAccount) {
            if (this.checkSelectedAccountStatus(enableAccount ? 'disabled' : 'active')) return

            const form = new FormData()
            form.append('id', this.selectedAccounts.join(','))
            form.append('account_status', 1)
            form.append('disable', enableAccount ? 0 : 1)

            this.$store.commit('modal/toggleModal', {
                modalType: 'warning',
                modalName: 'confirm-modal',
                modalDesc: `Are you sure you want to ${ enableAccount ? 'enable' : 'disable' } this account(s)?`,
                storeAction: 'registeredAccount/enableDisableAccount',
                storePayload: form
            })
        },

        /* Toggle Create */
        toggleCreateModal () {
            // this.$store.commit('modal/toggleModal', {
            //     modalName: 'account-form'
            // })

            this.$router.push('/registed-accounts/create')
        },

        /* Template Methods */
        checkSelectedAccountStatus (accountStatus) {
            return !this.list.data
                            .filter(x => this.selectedAccounts.indexOf(x.id) > -1)
                            .every(y => y.status.toLowerCase() === accountStatus)
        }
    },

    components: {
        // DropdownOption,
    },
}
</script>

<style lang="scss" scoped>
.account-controls {
    display: flex;
    button:not(:first-child) {
        margin-left: 10px;
    }
}
</style>